/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Hero_Lead_LinkInputs */

const en_cp_hero_lead_link = /** @type {(inputs: Cp_Hero_Lead_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student? Become the Campus Lead at your university →`)
};

const id_cp_hero_lead_link = /** @type {(inputs: Cp_Hero_Lead_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahasiswa? Jadi Campus Lead di kampusmu →`)
};

/**
* | output |
* | --- |
* | "Student? Become the Campus Lead at your university →" |
*
* @param {Cp_Hero_Lead_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_hero_lead_link = /** @type {((inputs?: Cp_Hero_Lead_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Hero_Lead_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_hero_lead_link(inputs)
	return en_cp_hero_lead_link(inputs)
});